<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  category: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <BasicBlock
    :icon="['fal', 'tag']"
    :ariaDescription="$t('meeting.category')"
    :text="category"
  >
  </BasicBlock>
</template>
